import { render, staticRenderFns } from "./AppBreadCrumb.vue?vue&type=template&id=91f31c1c&"
import script from "./AppBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default})
